import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { PrimeTemplate } from 'primeng/api'
import { AutoComplete } from 'primeng/autocomplete'
import { BALZACBook } from '@app/interfaces/balzac-books'
import { BALZACBooksApi } from '@app/apis/balzac-books.api'
import { DetailMode } from '@app/components/generic/generic.constants'
import type { ArchivesBalzacBooksBALZACBook } from '@app/generated/api/model'

@Component({
  selector: 'app-balzac-book-field',
  templateUrl: 'balzac-book-field.component.html',
  styleUrl: 'balzac-book-field.component.less',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
    PrimeTemplate,
  ],
})
export class BalzacBookFieldComponent implements OnInit, OnChanges {
  public readonly balzacBooksApi = inject(BALZACBooksApi)

  @Input() balzacBook?: BALZACBook
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() balzacBookChange = new EventEmitter<BALZACBook | undefined>()

  public allBalzacBookSagaNames: string[] = []
  public allBalzacBooks: ArchivesBalzacBooksBALZACBook[] = []
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    this.allBalzacBookSagaNames = []
  }

  ngOnChanges (changes: SimpleChanges) {
    if (changes.balzacBook) {
      this.balzacBookChange.emit(this.balzacBook)
    }
  }

  /**
   * Return project codes matching the given code using an `icontains` matcher.
   * This is necessary because we cannot present a list of *all* projects: it must be pre-filtered.
  */
  getBalzacSuggestions ($event: { query: string, originalEvent: any }) {
    this.balzacBooksApi.list({ limit: 100, ordering: 'saga_name', saga_name: $event.query, exclude_france: true }).subscribe(
      res => {
        this.allBalzacBooks = res.results
      })
  }
}
